import type { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";

type Currency = {
  label: string;
  name: string;
  description: string;
  icon: React.ReactNode;
};

export const getFiatCurrencies = (
  t: ReturnType<typeof useTranslations>
): Currency[] => [
  {
    label: "AUD",
    description: t("Currencies.AUD"),
    name: "AU$ - AUD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/au.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "CAD",
    description: t("Currencies.CAD"),
    name: "CA$ - CAD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/ca.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "EUR",
    description: t("Currencies.EUR"),
    name: "€ - EUR",
    icon: (
      <Image
        src="/assets/v2/icons/flags/eu.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "GBP",
    description: t("Currencies.GBP"),
    name: "£ - GBP",
    icon: (
      <Image
        src="/assets/v2/icons/flags/gb.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "CNY",
    description: t("Currencies.CNY"),
    name: "¥ - CNY",
    icon: (
      <Image
        src="/assets/v2/icons/flags/cn.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "HKD",
    description: t("Currencies.HKD"),
    name: "HK$ - HKD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/hk.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "INR",
    description: t("Currencies.INR"),
    name: "₹ - INR",
    icon: (
      <Image
        src="/assets/v2/icons/flags/in.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "KRW",
    description: t("Currencies.KRW"),
    name: "₩ - KRW",
    icon: (
      <Image
        src="/assets/v2/icons/flags/kr.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "SGD",
    description: t("Currencies.SGD"),
    name: "S$ - SGD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/sg.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "USD",
    description: t("Currencies.USD"),
    name: "$ - USD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/us.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "VND",
    description: t("Currencies.VND"),
    name: "₫ - VND",
    icon: (
      <Image
        src="/assets/v2/icons/flags/vn.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "AED",
    description: t("Currencies.AED"),
    name: "د.إ - AED",
    icon: (
      <Image
        src="/assets/v2/icons/flags/ae.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },

  {
    label: "JPY",
    description: t("Currencies.JPY"),
    name: "¥ - JPY",
    icon: (
      <Image
        src="/assets/v2/icons/flags/jp.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "CHF",
    description: t("Currencies.CHF"),
    name: "CHF - CHF",
    icon: (
      <Image
        src="/assets/v2/icons/flags/ch.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "BRL",
    description: t("Currencies.BRL"),
    name: "R$ - BRL",
    icon: (
      <Image
        src="/assets/v2/icons/flags/br.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "RUB",
    description: t("Currencies.RUB"),
    name: "₽ - RUB",
    icon: (
      <Image
        src="/assets/v2/icons/flags/ru.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "MXN",
    description: t("Currencies.MXN"),
    name: "MX$ - MXN",
    icon: (
      <Image
        src="/assets/v2/icons/flags/mx.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "ZAR",
    description: t("Currencies.ZAR"),
    name: "R - ZAR",
    icon: (
      <Image
        src="/assets/v2/icons/flags/za.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "NZD",
    description: t("Currencies.NZD"),
    name: "NZ$ - NZD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/nz.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "NOK",
    description: t("Currencies.NOK"),
    name: "kr - NOK",
    icon: (
      <Image
        src="/assets/v2/icons/flags/no.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "SEK",
    description: t("Currencies.SEK"),
    name: "kr - SEK",
    icon: (
      <Image
        src="/assets/v2/icons/flags/se.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "DKK",
    description: t("Currencies.DKK"),
    name: "kr - DKK",
    icon: (
      <Image
        src="/assets/v2/icons/flags/dk.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "TRY",
    description: t("Currencies.TRY"),
    name: "₺ - TRY",
    icon: (
      <Image
        src="/assets/v2/icons/flags/tr.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "THB",
    description: t("Currencies.THB"),
    name: "฿ - THB",
    icon: (
      <Image
        src="/assets/v2/icons/flags/th.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "ILS",
    description: t("Currencies.ILS"),
    name: "₪ - ILS",
    icon: (
      <Image
        src="/assets/v2/icons/flags/il.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "PLN",
    description: t("Currencies.PLN"),
    name: "zł - PLN",
    icon: (
      <Image
        src="/assets/v2/icons/flags/pl.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "MYR",
    description: t("Currencies.MYR"),
    name: "RM - MYR",
    icon: (
      <Image
        src="/assets/v2/icons/flags/my.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "IDR",
    description: t("Currencies.IDR"),
    name: "Rp - IDR",
    icon: (
      <Image
        src="/assets/v2/icons/flags/id.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "SAR",
    description: t("Currencies.SAR"),
    name: "﷼ - SAR",
    icon: (
      <Image
        src="/assets/v2/icons/flags/sa.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "TWD",
    description: t("Currencies.TWD"),
    name: "NT$ - TWD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/tw.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "ARS",
    description: t("Currencies.ARS"),
    name: "$ - ARS",
    icon: (
      <Image
        src="/assets/v2/icons/flags/ar.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "COP",
    description: t("Currencies.COP"),
    name: "$ - COP",
    icon: (
      <Image
        src="/assets/v2/icons/flags/co.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "CLP",
    description: t("Currencies.CLP"),
    name: "$ - CLP",
    icon: (
      <Image
        src="/assets/v2/icons/flags/cl.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "HUF",
    description: t("Currencies.HUF"),
    name: "Ft - HUF",
    icon: (
      <Image
        src="/assets/v2/icons/flags/hu.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "CZK",
    description: t("Currencies.CZK"),
    name: "Kč - CZK",
    icon: (
      <Image
        src="/assets/v2/icons/flags/cz.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "EGP",
    description: t("Currencies.EGP"),
    name: "E£ - EGP",
    icon: (
      <Image
        src="/assets/v2/icons/flags/eg.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "UAH",
    description: t("Currencies.UAH"),
    name: "₴ - UAH",
    icon: (
      <Image
        src="/assets/v2/icons/flags/ua.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "QAR",
    description: t("Currencies.QAR"),
    name: "﷼ - QAR",
    icon: (
      <Image
        src="/assets/v2/icons/flags/qa.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "KWD",
    description: t("Currencies.KWD"),
    name: "د.ك - KWD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/kw.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "RON",
    description: t("Currencies.RON"),
    name: "lei - RON",
    icon: (
      <Image
        src="/assets/v2/icons/flags/ro.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "BGN",
    description: t("Currencies.BGN"),
    name: "лв - BGN",
    icon: (
      <Image
        src="/assets/v2/icons/flags/bg.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "ISK",
    description: t("Currencies.ISK"),
    name: "kr - ISK",
    icon: (
      <Image
        src="/assets/v2/icons/flags/is.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "JOD",
    description: t("Currencies.JOD"),
    name: "د.ا - JOD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/jo.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "OMR",
    description: t("Currencies.OMR"),
    name: "﷼ - OMR",
    icon: (
      <Image
        src="/assets/v2/icons/flags/om.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "AZN",
    description: t("Currencies.AZN"),
    name: "₼ - AZN",
    icon: (
      <Image
        src="/assets/v2/icons/flags/az.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "BHD",
    description: t("Currencies.BHD"),
    name: ".د.ب - BHD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/bh.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "XOF",
    description: t("Currencies.XOF"),
    name: "CFA - XOF",
    icon: (
      <Image
        src="/assets/v2/icons/flags/sn.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "FJD",
    description: t("Currencies.FJD"),
    name: "FJ$ - FJD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/fj.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "GEL",
    description: t("Currencies.GEL"),
    name: "₾ - GEL",
    icon: (
      <Image
        src="/assets/v2/icons/flags/ge.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "KZT",
    description: t("Currencies.KZT"),
    name: "₸ - KZT",
    icon: (
      <Image
        src="/assets/v2/icons/flags/kz.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "MOP",
    description: t("Currencies.MOP"),
    name: "MOP$ - MOP",
    icon: (
      <Image
        src="/assets/v2/icons/flags/mo.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "MDL",
    description: t("Currencies.MDL"),
    name: "L - MDL",
    icon: (
      <Image
        src="/assets/v2/icons/flags/md.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
  {
    label: "NAD",
    description: t("Currencies.NAD"),
    name: "N$ - NAD",
    icon: (
      <Image
        src="/assets/v2/icons/flags/na.svg"
        height={32}
        alt="icon"
        width={32}
      />
    ),
  },
];
